import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { ErrorMessage } from '~/components/ErrorMessage';
import { ResponseError } from '~/domain/ResponseError';

interface IGenericErrorMessage {
  error: Error | ResponseError;
}

export const GenericErrorMessage: React.FC<IGenericErrorMessage> = (props) => {
  const { error } = props;
  const { status = 500 } = error as Partial<ResponseError>;
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        align="center"
        color="textPrimary"
        variant="h1"
        sx={{ mb: 2 }}
      >
        {status}: Oops, something went wrong.
      </Typography>
      <ErrorMessage error={error} />
    </Box>
  );
};
